import { Dossier } from '@sc/data-access-models';
import { FilterDossiersStates } from '../../models/dossiers-states';

export class SetFiltersSearchDossiersAction {
  static readonly type = '[SearchDossiers] Set filters';

  constructor(
    public payload: { search: string; dossiersStates: FilterDossiersStates }
  ) {}
}

export class SetDossiersSearchDossiersAction {
  static readonly type = '[SearchDossiers] Set dossiers';

  constructor(public payload: { dossiers: Dossier[] }) {}
}
